import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedService } from 'app/modules/common/services/shared-service';
import { UserManagementService } from 'app/modules/users/services/user-management.service';


@Component({
    selector: 'app-permit-groups',
    templateUrl: './permit-groups.component.html',
    styleUrls: ['./permit-groups.component.scss'],
    standalone: false
})
export class PermitGroupsComponent implements OnChanges {

  @Input() grupo :string
  @Input() roleType  :string

  public tableValues:any
  public loaded= false
  
  constructor(
    private _userManagementService :UserManagementService,
    private _sharedService : SharedService
    ) {     
  }

  ngOnChanges(changes: SimpleChanges): void { 
    //set changed role type
    this.roleType = changes['roleType'].currentValue
    this.grupo = changes['grupo']? changes['grupo'].currentValue : this.grupo;
    this.getRolePermits(this.roleType,this.grupo)
  }
   
  public validatePermit(role : any , permit: any): boolean{    
    let val = permit.rolePermits.filter(p => { return p.rolId == role.id })
      return val.length > 0 
  }

  public getRolePermits(tipo: string,grupo: string){
    //if tipo value +/- convert into word
    if(tipo != 'P') tipo = tipo == '+'? 'plus' : 'minus';
    this._userManagementService.getRolePermits(tipo,grupo).subscribe(response=>{
      this.tableValues = response.result 
      this.loaded= true
    })
  }

  public checkBoxChanged(event : MatCheckboxChange, roleId, permissionId){
    if(event.checked){
      this.addRolePermit(roleId,permissionId)
    }else{
      this.deleteRolePermit(roleId,permissionId)
    }   
  }

  public addRolePermit(rolId: any,permisoId:any) {    
    this._userManagementService.addRolePermit({rolId: rolId, permisoId: permisoId})
      .subscribe(res => {
        if (res.code === 0 && res.result) {
          this._sharedService.ShowSnackBar('Guardado con éxito');
        } else {
          this._sharedService.ShowSnackBar('Error al crear');
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error');
        console.error(err);
      });
  }

  public deleteRolePermit(rolId: number, permisoId: number) {    
        this._userManagementService.deleteRolePermit(rolId, permisoId).subscribe(result => {
          if (result) {           
            this._sharedService.ShowSnackBar('Borrado exitosamente', 'Okay', 2000);
          } else {
            this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
        });
      }  
}
